module.exports = __webpack_public_path__ + "static/other/2e_space_port.0baf0a6a.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/2e_space_port.json
// module id = 2475
// module chunks = 0